export default {
  computed: {
    schemaEvaluasiPip() {
      return [
        {
          title: '',
          key: 'smk-pip',
        },
        {
          title:
            'Berikut ini terdapat sejumlah pernyataan terkait aspek kinerja Fasilitator/Pengajar  dalam IHT SMK PK. Berilah penilaian dalam rentang 1 (kurang baik), 2 (cukup baik), 3 (baik), 4 (sangat baik) terhadap performa Fasilitator/Pengajar pada materi ini',
          key: 'smk-pip-1',
          model: 'table',
        },
        {
          title: '',
          key: 'smk-pip-2',
        },
      ];
    },
  },
};
